/*
 * @Description: 
 * @Version: 1.0
 * @Author: zhouxh
 * @Date: 2023-11-21 09:41:39
 * @LastEditors: zhouxh
 * @LastEditTime: 2025-12-10 08:55:03
 */
import Mock from "mockjs"

Mock.mock("/index.php/about-honor","get",{
    code: 0,//错误码
    msg: "",//错误消息
    //data为具体的消息内容，如果code不为0，则必为null
    data: [
      
        {   
            id:1,
            text: `2025年合庆政府--合庆领航奖`,
            img: [
                require("@/assets/img/About/qiyerongyu1/heqing.png"),
                require("@/assets/img/About/qiyerongyu1/heqing1.png"),
            ]
        },



        {   
            id:2,
            text: `2018年--浦东新区企业研发机构`,
            img: [
                require("@/assets/img/About/qiyerongyu1/浦东新区企业研发机构.jpg"),
            ]
        },











        {   
            id:3,
            text: `2025年浦东新区--营运总部称号`,
            img: [
                require("@/assets/img/About/qiyerongyu1/pudongxinqu.png"),
                require("@/assets/img/About/qiyerongyu1/pudongxinqu1.png"),
            ]
        },



         {   
            id:4,
            text: `2024年--专精特新"小巨人"企业`,
            img: [
                require("@/assets/img/About/qiyerongyu1/专精特新小巨人.jpg"),
            ]
        },






        {   
            id:5,
            text: `2022年--上海市科技小巨人`,
            img: [
                require("@/assets/img/About/qiyerongyu1/上海市科技小巨人.jpg"),
            ]
        },


        {   
            id:6,
            text: `2022年--高新技术企业`,
            img: [
                require("@/assets/img/About/qiyerongyu1/高新技术企业.png"),
            ]
        },


        {   
            id:7,
            text: `2025年--上海市专家工作站`,
            img: [
                require("@/assets/img/About/qiyerongyu1/专家工作站.jpg"),
            ]
        },



        {   
            id:8,
            text: `2025年--上海市企业技术中心`,
            img: [
                require("@/assets/img/About/qiyerongyu1/上海市企业技术中心.jpg"),
            ]
        },








  

 


    ]
})